import { render } from "./Vote.vue?vue&type=template&id=a6370bf0&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"

import "./Vote.vue?vue&type=style&index=0&id=a6370bf0&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6370bf0"]])

export default __exports__